export default __webpack_public_path__ + "static/media/iconFR.dd2e88b1.svg";